import { createSelector } from '@reduxjs/toolkit'

export const appStore = (state) => state.app

export const selectAppLoadingState = createSelector(
  appStore,
  (app) => app.loading,
)

export const selectAppNotification = createSelector(
  appStore,
  (app) => app.notification,
)

export const selectAppNotifications = createSelector(
  appStore,
  (app) => app.notifications,
)

export const selectTimerId = createSelector(
  appStore,
  (app) => app.timerId,
)

export const selectAppCurrentSteep = createSelector(
  appStore,
  (app) => app.currentSteep,
)

export const selectAppTraveled = createSelector(
  appStore,
  (app) => app.traveled,
)

export const selectAppError = createSelector(
  appStore,
  (app) => ({ error: app.error, errorMessage: app.errorMessage }),
)

export const selectLogo = createSelector(
  appStore,
  (app) => app.logoPath,
)

export const selectBrand = createSelector(
  appStore,
  (app) => app.brand,
)

export const selectBranding = createSelector(
  appStore,
  (app) => {
    return {
      name: process.env.REACT_APP_WHITE_LABEL_TITLE || 'akko',
      color: process.env.REACT_APP_WHITE_LABEL_COLOR || '#F3103D',
      logoUrl: process.env.REACT_APP_WHITE_LABEL_BRAND_IMAGE_URL || '/brands/akko.png',
      brandName: process.env.REACT_APP_WHITE_LABEL_BRAND_NAME || 'AKKO Claims',
      tabIconUrl: process.env.REACT_APP_WHITE_LABEL_FAVICON_LINK || '/favicons/favicon-16x16.png',
    }
  },
)

export const selectThemes = createSelector(
  appStore,
  (app) => app.themes,
)

export const selectPagesVisited = createSelector(
  appStore,
  (app) => app.pagesVisited,
)

export const selectPageVisitedByName = createSelector(
  [appStore, (_, pageName) => pageName],
  (app, pageName) => app.pagesVisited[pageName],
)

export const selectAddHideCssMobile = createSelector(
  appStore,
  (app) => app.addHideCssMobile,
)
